import React from 'react';
import { Link } from 'react-router-dom';
import LockIcon from '@mui/icons-material/Lock';
import styles from './AuthPrompt.module.css';

export default function AuthPrompt() {
  return (
    <div className={styles.authPrompt}>
      <LockIcon className={styles.lockIcon} />
      <h2 className={styles.title}>Create Your Own Playbooks</h2>
      <p className={styles.description}>
        Join Odikai to create, customize, and save your own betting playbooks. 
        Track your performance and refine your strategies over time.
      </p>
      <div className={styles.authButtons}>
        <Link to="/login" className={styles.primaryButton}>
          Sign In
        </Link>
        <Link to="/register" className={styles.secondaryButton}>
          Create Account
        </Link>
      </div>
    </div>
  );
} 